import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CrewRatingsChartViewComponent } from './components/crew-ratings-detail/crew-ratings-chart-view/crew-ratings-chart-view.component';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { AnalyticsRoutingModule } from './analytics-routing.module';
import { CrewsRatingsListComponent } from './components/analytics/crews-ratings-list/crews-ratings-list.component';
import { AnalyticsComponent } from './components/analytics/analytics.component';
import { CrewRatingsDetailComponent } from './components/crew-ratings-detail/crew-ratings-detail.component';
import { SafetyRatingFeedbackComponent } from './components/safety-rating-feedback/safety-rating-feedback.component';
import { CrewRatingsListViewComponent } from './components/crew-ratings-detail/crew-ratings-list-view/crew-ratings-list-view.component';
import { AnalyticsContainerComponent } from './analytics-container.component';

import { CoreModule } from './../../core/core.module';
import { SharedModule } from './../../shared/shared.module';

import { NgChartjsModule } from 'ng-chartjs';
import { ChartsModule } from 'ng2-charts';
import { FormsModule } from '@angular/forms';
import { SubmitterDetailsDialogueComponent } from './components/submitter-details-dialogue/submitter-details-dialogue.component';
import { CrewRatingsChartComponent } from './components/analytics/crew-ratings-chart/crew-ratings-chart.component';
import { LineChartComponent } from './components/charts/line-chart/line-chart.component';
import { BarChartComponent } from './components/charts/bar-chart/bar-chart.component';
import { ParetoChartComponent } from './components/charts/pareto-chart/pareto-chart.component';

@NgModule({
  declarations: [
    CrewsRatingsListComponent,
    CrewRatingsChartViewComponent,
    CrewRatingsListViewComponent,
    AnalyticsComponent, CrewRatingsDetailComponent,
    SafetyRatingFeedbackComponent,
    AnalyticsContainerComponent,
    SubmitterDetailsDialogueComponent,
    CrewRatingsChartComponent,
    LineChartComponent,
    BarChartComponent,
    ParetoChartComponent],
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    NgbModule,
    AnalyticsRoutingModule,
    NgChartjsModule,
    ChartsModule,
    FormsModule
  ],
  exports: [
    SubmitterDetailsDialogueComponent,
  ],
  entryComponents: [
    SubmitterDetailsDialogueComponent
  ],
  providers: [DatePipe]
})
export class AnalyticsModule { }
